export default __webpack_public_path__ + "static/media/bannerDesktop.293e5948.jpg";